import { tool, zodSchema } from 'ai';
import { z } from 'zod';
import type { AiTool } from '@erikdakoda/ai-tool/types';
import { promptsToolGroupIcon } from './toolGroupIcon';
import { ormToolQueryArgsSchema } from '@erikdakoda/ai-tool/types';
import { withAiToolNestedParamSchema } from '@erikdakoda/ai-tool/findManyAiToolInput';
import { createPromptSelectSchema } from './botAiToolInputSchemas';
import { PromptForAiToolsSchema } from './PromptForAiTools';

const promptUpdateBodySchema = PromptForAiToolsSchema.omit({
  id: true,
  ownerId: true,
  spaceId: true,
  slug: true,
  createdAt: true,
  updatedAt: true,
}).partial();

export const updatePromptInputSchema = z.object({
  promptId: z.string(),
  prompt: withAiToolNestedParamSchema(promptUpdateBodySchema, 'prompt').describe(
    'Fields to change, including optional `publishedAt` (set a date to publish, null to unpublish).',
  ),
  select: createPromptSelectSchema,
});

export const updatePromptOutputSchema = z.object({
  queryArgs: ormToolQueryArgsSchema,
  queryResult: z
    .unknown()
    .nullable()
    .describe('Updated row; default mask when `select` omitted, else matches caller `select`.'),
  success: z.string().nullable(),
  error: z.unknown().nullable(),
});

export type UpdatePromptInput = z.infer<typeof updatePromptInputSchema>;
export type UpdatePromptOutput = z.infer<typeof updatePromptOutputSchema>;

export const updatePrompt: AiTool<undefined, UpdatePromptInput, UpdatePromptOutput> = {
  id: 'updatePrompt',

  group: 'prompts',

  ...promptsToolGroupIcon,

  userSelect: false,

  access: 'WRITE',

  tool: tool({
    description: 'Update an existing prompt by id.',
    inputSchema: zodSchema(updatePromptInputSchema),
    outputSchema: zodSchema(updatePromptOutputSchema),
  }),
};
